export const appRoutes = {
  landing: "/",
  callback: "/auth/callback",
  login: "/login",
  anomalyDetect: "/anomaly",
  reports: "/reports",
  alerts: "/alerts",
  noAccess: "/no-access",
};
